import { Divider, Grid, Typography } from '@mui/material';
import { useStyles } from './styles';
import HelperIconWithTooltip from 'src/shared/components/HelperIconWithTooltip';
import clsx from 'clsx';

type GroupHeaderProps = {
  children: string;
  marginTop?: number;
  tooltipTitle?: string;
  className?: string;
};

const GroupHeader = ({ children, marginTop, tooltipTitle, className }: GroupHeaderProps) => {
  const maybeMarginTop: number = marginTop as number;
  const classes = useStyles({ marginTop: maybeMarginTop });

  return (
    <Grid item md={12} className={classes.generalGroupHeaderWrapper}>
      <Typography className={clsx(classes.generalGroupHeader, className)} variant="h3">
        {children}
        {tooltipTitle && <HelperIconWithTooltip className={classes.tooltip} title={tooltipTitle} />}
      </Typography>
      <Divider className={classes.divider} />
    </Grid>
  );
};

export default GroupHeader;
